import { render, staticRenderFns } from "./goodsReserve.vue?vue&type=template&id=2c1e69f8&"
import script from "./goodsReserve.vue?vue&type=script&lang=js&"
export * from "./goodsReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports